module.exports = __webpack_public_path__ + "img/Taiwan-4.6181f72f.jpg";